export function formDataToObj (formData) {
  const obj = {};
  formData.forEach((value, key) => {
    obj[key] = value;
  });
  return obj;
}

export function truncateString (str, num) {
  if (str == null) {
    str = '';
  }
  if (num == null) {
    return str;
  }
  if (num <= 0) {
    return '...';
  }
  if (num >= str.length) {
    return str;
  }
  var newStr = str.substr(0, num);
  if (/[\uD800-\uDBFF]/.test(str.charAt(num - 1)) && /[\uDC00-\uDFFF]/.test(str.charAt(num))) {
    newStr = newStr.substr(0, newStr.length - 1);
  }
  return newStr + '...';
}
